import { APP_INITIALIZER, NgModule } from '@angular/core';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Angulartics2Module } from 'angulartics2';
import { MarkdownModule, MarkedOptions, MarkedRenderer } from 'ngx-markdown';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { ApplicationUrls } from './configuration/application-urls';
import { BrowserModule } from '@angular/platform-browser';
import { ConfigurationLoaderService } from './configuration/configuration-loader.service';
import { CoreModule } from '@core/core.module';
import { SharedModule } from '@shared/shared.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AngularMaterialModule } from "./angular-material/angular-material-module";

import { SocketIoConfig, SocketIoModule } from 'ngx-socket-io';

import { DialogDemoInformationComponent } from './angular-material/components/dialog-demo-information.component';
import { WgThemerModule, config } from "wg-themer";
import { MaterialCssVarsModule } from 'angular-material-css-vars';

export const configFactory = (configService: ConfigurationLoaderService) => {
  return () => configService.configure();
};

const socketConfig: SocketIoConfig = { url: environment.API_BASE_URL, options: {} };

// function that returns `MarkedOptions` with renderer override
export function markedOptionsFactory(): MarkedOptions {
  const renderer = new MarkedRenderer();
  const linkRenderer = renderer.link;

  renderer.link = (href, title, text) => {
    const html = linkRenderer.call(renderer, href, title, text);
    return html.replace(/^<a /, '<a role="link" tabindex="0" target="_blank" rel="nofollow noopener noreferrer" ');
  };

  return {
    renderer,
    gfm: true,
    breaks: false,
    pedantic: false,
    smartLists: true,
    smartypants: false,
  };
}

@NgModule({
  declarations: [
    AppComponent,
    DialogDemoInformationComponent
  ],
  imports: [
    BrowserModule,
    CoreModule,
    SharedModule,
    AppRoutingModule,
    HttpClientModule,
    Angulartics2Module.forRoot(),
    BrowserAnimationsModule,
    AngularMaterialModule,
    WgThemerModule,
    MaterialCssVarsModule.forRoot(config),
    SocketIoModule.forRoot(socketConfig),
    MarkdownModule.forRoot({
      loader: HttpClient,
      markedOptions:{
        provide: MarkedOptions,
        useFactory: markedOptionsFactory
    }
   })
  ],
  providers: [
    {
      provide: ApplicationUrls,
      deps: [HttpClient],
      useExisting: ConfigurationLoaderService
    },
    {
      provide: APP_INITIALIZER,
      useFactory: configFactory,
      deps: [ConfigurationLoaderService],
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
